import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: auto;
`;

export const Content = styled.div``;
